/* HOW FERAL R U: the same integer-money projection in the browser and engine.
   No network, persistence, clocks or side effects. Amounts are GBP pence until
   a reward is selected from the programme's explicit currency table. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.HFRewards = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function integer(n, name) {
    if (!Number.isSafeInteger(n) || n < 0) throw new TypeError(name + ' must be a non-negative safe integer');
    return n;
  }
  function config(rules) {
    var per = rules.gbp_per_pct || rules.score && rules.score.gbp_per_pct;
    var unit = integer(Math.round(per * 100), 'pence per percent');
    if (!unit || !rules.drops || !rules.drops.every_pct || !rules.levels || !rules.levels.length) throw new TypeError('incomplete programme rules');
    return { unit: unit, step: integer(unit * rules.drops.every_pct, 'drop threshold'), levels: rules.levels, rows: rules.benefits.rows };
  }
  function rank(rules, minor, orders) {
    var c = config(rules), at = 0;
    c.levels.forEach(function (l, i) { if ((!l.requires_order || orders > 0) && minor >= Math.round(l.min_pct * c.unit)) at = i; });
    return at;
  }
  function state(rules, input) {
    var c = config(rules), s = input || {};
    var minor = integer(s.net_minor || 0, 'net spend'), orders = integer(s.orders || 0, 'order count');
    var held = integer(s.level || 0, 'level');
    if (held >= c.levels.length) throw new RangeError('unknown level');
    return { net_minor: minor, orders: orders, pct: Math.floor(minor / c.unit), level: Math.max(held, rank(rules, minor, orders)), drop_cursor: Math.max(integer(s.drop_cursor || 0, 'drop cursor'), Math.floor(minor / c.step)) };
  }
  function project(rules, before, addMinor) {
    var c = config(rules), s = state(rules, before);
    integer(addMinor, 'order amount');
    var net = integer(s.net_minor + addMinor, 'projected spend');
    var after = state(rules, {net_minor: net, orders: s.orders + (addMinor > 0 ? 1 : 0), level: s.level, drop_cursor: s.drop_cursor});
    var regular = Math.max(0, Math.floor(net / c.step) - s.drop_cursor), ups = [], backs = [];
    for (var k = s.drop_cursor + 1; k <= Math.floor(net / c.step); k++) backs.push(backAt(rules, k, s.level, after.orders));
    var row = c.rows.find(function (r) { return r.key === 'levelup'; });
    for (var i = s.level + 1; i <= after.level; i++) {
      var e = row && row.at[c.levels[i].key];
      if (e && e.gbp) ups.push({level: c.levels[i].key, gbp: e.gbp});
    }
    return {before: s, after: after, regular: regular, backs: backs, regular_x: backs.reduce(function (n, x) { return n + x; }, 0), levelups: ups, next_drop_minor: Math.max(0, (after.drop_cursor + 1) * c.step - net), next_x: backAt(rules, after.drop_cursor + 1, after.level, after.orders)};
  }
  /* The rate a credit milestone pays is the level held when it is reached:
     milestone k sits at k * step of eligible spend. Levels never fall, so
     the held level is a floor. Multipliers are whole numbers, which keeps
     every currency amount an exact integer in minor units. */
  function multiplier(rules, index) {
    var l = rules.levels[index], x = rules.drops.multiplier && l && rules.drops.multiplier[l.key];
    return x ? integer(x, 'credit multiplier') : 1;
  }
  function backAt(rules, k, held, orders) {
    var c = config(rules);
    return multiplier(rules, Math.max(held || 0, rank(rules, k * c.step, Math.max(orders || 0, 1))));
  }
  function rewardMinor(rules, reward, iso) {
    var amount;
    if (reward.kind === 'order') amount = rules.drops.value && rules.drops.value[iso] && rules.drops.value[iso] * integer(reward.x || 1, 'credit multiplier');
    else {
      var fx = rules.benefits.fx_display && rules.benefits.fx_display[iso];
      if (fx) amount = Math.round(reward.gbp * fx);
    }
    if (!(amount > 0)) return null;
    return integer(Math.round(amount * 100), 'reward amount');
  }
  return Object.freeze({config: config, rank: rank, state: state, project: project, multiplier: multiplier, backAt: backAt, rewardMinor: rewardMinor});
});
